import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disable",
  "use": "disable-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"disable\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.107 6.107a8.333 8.333 0 1111.786 11.786A8.333 8.333 0 016.107 6.107zM19.071 4.93c-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.293 17.293l12-12 1.414 1.414-12 12-1.414-1.415z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol